import ReduxHooks from '../../../../store/ReduxHooks';
import { actionCreators } from '../../../../store/actions';

/**
 * Connection state only — the printers list is refreshed by PrintersUpdatedHandler, since
 * a printer going offline or coming back says nothing about what is in the list.
 */
export default class ConnectExternalPrinterHandler {
  static type = 'CONNECT_EXTERNAL_PRINTER';

  payload = null;

  constructor(payload) {
    this.payload = payload;
  }

  notify() {
    ReduxHooks.dispatch(actionCreators.print.setExternalPrinterConnected(!!this.payload?.externalPrinterConnected));
    ReduxHooks.dispatch(actionCreators.print.setExternalPrinterStatus(this.payload?.externalPrinterStatus ?? null));
  }
}
